<template>
  <vx-card class="campaign-summary" :noShadow="true">
    <div v-for="(adset, index) in data.adsets" :key="'adset-summary-' + index">
      <div class="vs-row header-divider">
        <vs-divider v-if="index == 0" />

        <p class="font-bold mb-3 custom-type-style">
          {{ $t('Ad Set') }} {{ index + 1 }}:
        </p>
        <p class="mb-3 custom-type-style">
          {{ adset.name }}
        </p>
      </div>

      <vs-divider class="custom-divider-style" />

      <div class="vs-row">
        <p class="font-bold mb-3 custom-type-style">
          {{ $t('What are you optimizing for?') }}
        </p>
        <p class="mb-3 custom-type-style">
          {{ bidType(adset) }}
        </p>

        <vs-divider class="custom-divider-style" />

        <p class="font-bold mb-3 custom-type-style">
          {{ costPerActionLable(adset) }}
        </p>
        <p class="mb-3 custom-type-style">
          ${{ adset.budget.cost_per_action }}
        </p>

        <div v-if="allowAlternativeOption">
          <vs-divider class="custom-divider-style" />

          <p class="font-bold mb-3 custom-type-style">
            {{ $t('Alternative Option (CPC)') }}
          </p>
          <p class="mb-3 custom-type-style">
            ${{ adset.budget.fallback_cpc }}
          </p>
        </div>

        <vs-divider class="custom-divider-style" />

        <p class="font-bold mb-3 custom-type-style">
          {{ $t(data.end_date === null ? 'Daily Cap' : 'Budget') }}
        </p>
        <p class="mb-3 custom-type-style">
          ${{ adset.budget.budget_value }}
        </p>
      </div>

      <vs-divider v-if="index + 1 != data.adsets.length" class="custom-divider-style" />
    </div>

    <div class="vs-row mt-4 custom-summary-button-style" v-if="!editing">
      <vs-button id="create-campaign-summary-s4-button" color="primary" type="filled" class="w-full text-sm block m-auto rounded-sm" @click="goToStep()">
        {{ $t('Bidding') }}
      </vs-button>
    </div>
  </vx-card>
</template>

<script>
import biddingTypes from '@/views/campaigns/biddingTypes.js'

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    objectiveId: {
      type: Number,
      required: true
    },
    editing: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      allowAlternativeOption: ![this.$constants.CAMPAIGN_OBJECTIVES_IDS.FACEBOOK_OUTCOME_CONVERSION_LEADS, this.$constants.CAMPAIGN_OBJECTIVES_IDS.FACEBOOK_OUTCOME_CONVERSION_SALES].includes(this.objectiveId)
    }
  },
  methods: {
    goToStep () {
      const wizard = this.$parent.$parent.$parent.$parent.$parent.$parent.$refs.campaignWizard

      wizard.navigateToTab(3)
    },
    bidType (adset) {
      const type =  biddingTypes[adset.budget.optimizing_for] || {}

      return (type.short || '').toUpperCase()
    },
    costPerActionLable (adset) {
      const type =  biddingTypes[adset.budget.optimizing_for] || {}

      return type.text || ''
    }
  }
}
</script>
